import React, { type ErrorInfo } from 'react';
import { useAnalytics } from '../../analytics';

import { ErrorScreen } from './ErrorScreen';
import { ErrorBoundaryAnalytics } from './ErrorBoundaryAnalytics';
import { BaseErrorBoundary } from './BaseErrorBoundary';

export interface ErrorBoundaryProps {
	children: React.ReactNode;
	errorCallback?: () => void;
}

export const ErrorBoundary = (props: ErrorBoundaryProps): React.JSX.Element => {
	const analytics = useAnalytics(ErrorBoundaryAnalytics);
	const { children, errorCallback } = props;
	const onError = (error: Error, info?: ErrorInfo) => {
		analytics.errorBoundaryRendered({
			error: {
				message: error.message,
				stack: info?.componentStack || error.stack,
			},
		});

		analytics.inviteFormFailedToLoad({
			message: error.message,
			stack: info?.componentStack || error.stack,
		});

		errorCallback && errorCallback();
	};

	return (
		<BaseErrorBoundary ErrorComponent={ErrorScreen} onError={onError}>
			{children}
		</BaseErrorBoundary>
	);
};

export default ErrorBoundary;
